export default [{
	path: 'manage',
	meta: {
		title: '维修管理'
	},
	component: () => import('@/pages/repair/manage')
}, {
	path: 'record/edit',
	meta: {
		title(route) {
			return route.query.id ? '编辑维修记录' : '添加维修记录'
		}
	},
	props: route => route.query,
	component: () => import('@/pages/repair/record_edit')
}, {
	path: 'record',
	meta: {
		title: '维修记录'
	},
	props: route => route.query,
	component: () => import('@/pages/repair/record')
}, {
	path: 'delivery',
	meta: {
		title: '送修'
	},
	/**支持从商品列表带背贴码直接进入预填，门店版没有扫码送修的工作台*/
	props: route => route.query,
	component: () => import('@/pages/repair/delivery')
}, {
	path: 'finish',
	meta: {
		title: '送修完成'
	},
	props: route => route.query,
	component: () => import('@/pages/repair/finish')
}]